import z from "zod";

const count = z.number().int().nonnegative();

/**
 * The counts the Templates tab of the fee schedules page shows, from
 * `GET /work/fee-schedule-templates/counts` (#6709): the templates that are not archived, and the
 * archived ones (#6716). Each takes the list's own criteria.
 */
export const FeeScheduleTemplateListCountsJSONZ = z.object({
  templates: count,
  archived: count,
});

export type FeeScheduleTemplateListCounts = z.infer<typeof FeeScheduleTemplateListCountsJSONZ>;
